'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { SellerStocklistType } from '@qogita/canary-client'
import { Icon } from '@qogita/ui/v2/icon'
import { useStockExpiryTimer } from 'src/hooks/use-stock-expiry-timer'

export function StockExpiryBanner({
  sellerStocklistType,
  stocklistExpiresAt,
}: {
  sellerStocklistType: SellerStocklistType | null
  stocklistExpiresAt: string | null
}) {
  const canFetchStocklistSource = sellerStocklistType === 'email'

  const remaining = useStockExpiryTimer(stocklistExpiresAt)

  if (!canFetchStocklistSource) {
    return null
  }

  if (!stocklistExpiresAt) {
    return null
  }

  if (remaining === null) {
    return null
  }

  const formatExpiryTime = new Intl.DateTimeFormat('en-GB', {
    hour: 'numeric',
    minute: 'numeric',
    timeZoneName: 'short',
  }).format(new Date(stocklistExpiresAt))

  const formatExpiryDate = new Intl.DateTimeFormat('en-GB', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(stocklistExpiresAt))

  // if deadline has passed => error
  // deadline is considered passed when we hit 0 minutes, not when seconds hit 0
  // such that users don't see 00:00:00
  if (remaining < 60 * 1000) {
    return (
      <div className="bg-error-900 flex w-full items-center justify-center gap-4 px-4 py-2.5 text-white">
        <Icon
          name="heroicons/outline/exclamation-triangle"
          className="size-4.5"
        />
        <span className="text-center text-sm font-medium">
          Your offers will not be visible to buyers until we receive your price
          list. If you have already sent your price list, changes may take up to
          30 minutes to reflect.
        </span>
      </div>
    )
  }

  // if there are 6h left until deadline => warning
  if (remaining > 0 && remaining <= 6 * 60 * 60 * 1000) {
    return (
      <div className="bg-caution-900 flex w-full items-center justify-center gap-4 px-4 py-2.5 text-white">
        <Icon
          name="heroicons/outline/exclamation-triangle"
          className="size-4.5"
        />
        <span className="text-center text-sm font-medium">
          Send your price list by {formatExpiryDate}, at {formatExpiryTime} to
          continue receiving orders. If you have already sent your price list,
          it may take up to 30 mins to update.
        </span>
      </div>
    )
  }

  return null
}
